import React from "react";

const HomeImage = () => {
  return (
    <div className="home-image">
      <img src="https://khushi2405.github.io/my-portfolio/assets/images/profileimg.jpg" alt="Khushi Gandhi" />
    </div>
  );
};

export default HomeImage;
